import { Component } from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import { TranslationKeyMap } from './auth.i18n';

@Component({
    selector: 'cmps-auth-login-modal',
    templateUrl: './modal.login.auth.component.html',
})
export class LoginModalAuthComponent {
    i18n = TranslationKeyMap;

    constructor(
        /** @priavte */ readonly _dialogRef: CmpsDialogRef<
            LoginModalAuthComponent,
            boolean
        >,
    ) {}
}
